export const localStorageAsync = {
  getItem: async (key: string): Promise<string | null> => {
    return window.localStorage.getItem(key);
  },
  setItem: async (key: string, value: string): Promise<void> => {
    window.localStorage.setItem(key, value);
  },
  removeItem: async (key: string): Promise<void> => {
    window.localStorage.removeItem(key);
  },
};

export const shouldDehydrateQuery = (query) => {
  if (!query.meta?.persist) {
    return false;
  }

  if (query.state.status !== 'success') {
    return false;
  }

  const ttl = query.meta?.ttl as number | undefined;
  if (!ttl) {
    return false;
  }

  const updatedAt = query.state.dataUpdatedAt;
  const isExpired = Date.now() - updatedAt > ttl;

  return !isExpired;
};

export const persistQuery = (ttl: number) => ({
  staleTime: ttl,
  gcTime: ttl,
  meta: {
    persist: true,
    ttl,
  },
});
